import React, { useState, useEffect } from "react";
import api from "../../api";
import {
  Paper,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  Dialog,
  DialogContent,
  TextField,
  IconButton,
  Button,
} from "@material-ui/core";
import ConfirmDialog from "../common/confirmDialog/ConfirmDialog";
import ReactSelect from "react-select";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DeleteIcon from "@material-ui/icons/Delete";
import CreateIcon from "@material-ui/icons/Create";
import utils from "../../utils/utils";
import Pagination from "@material-ui/lab/Pagination";
import Tooltip from "@material-ui/core/Tooltip";
import { SalesChannelAssign } from "../../enums/enums";
export default function SalesChannelList({
  setIsLoading,
  setDataToast,
  dataTable,
  classes,
  shortError,
  reloadData,
  paginationData,
}) {
  const [companiesListEdit, setCompaniesListEdit] = useState([]);
  const [salesChannelListEdit, setSalesChannelListEdit] = useState([]);
  const [externalSalesChannelListEdit, setExternalSalesChannelListEdit] = useState([]);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [viewData, setViewData] = useState();
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    id: undefined,
  });
  const [defaultValues, setDefaultValues] = useState({
    id: undefined,
    externalSalesChannelId: "",
    salesChannelId: "",
    companyId: "",
    sapCode: "",
  });
  const handleClickEdit = (id) => {
    setDefaultValues({
      id: undefined,
      externalSalesChannelId: "",
      salesChannelId: "",
      companyId: "",
      sapCode: "",
    });
    getSalesChannel(id);
  };
  const getSalesChannel = (id) => {
    setIsLoading(true);
    api
      .getSalesChannelById(id)
      .then((res) => {
        setDefaultValues({
          id: res.data.id,
          salesChannelId: res.data.canalDeVentaid,
          salesChannelName: res.data.nombreCanalDeVenta,
          companyId: res.data.compania.id,
          companyName: res.data.compania.nombre,
          externalSalesChannelId: res.data.canalDeVentaExterno.id,
          salesChannelName: res.data.nombreCanalVentaExterno,
          code: res.data.codigoCanalVentaExterno,
          sapCode: res.data.codigoCanalVentaSap,
        });
        let company = res.data.compania.id;
        api.getSalesChannel(company, SalesChannelAssign.All).then((res2) => {
          res2.data = utils.refactorDataInList(res2.data, defaultValues.salesChannelId);
          setSalesChannelListEdit(utils.setDataInSearchList(res2.data));
        });
        api.getExternalSalesChannelListByCompany(company, 1, 100).then((res3) => {
          if (res3.data.cantidad != 0) {
            res3.data.externalSalesChannels = utils.refactorDataInList(
              res3.data.externalSalesChannels,
              defaultValues.externalSalesChannelId
            );
            setExternalSalesChannelListEdit(utils.setDataInSearchList(res3.data.externalSalesChannels));
          }
        });
      })
      .catch((err) => {
        setViewData(false);
        shortError("Ocurrió un error.");
        setIsLoading(false);
      })
      .finally(() => {
        setViewData(true);
        setIsLoading(false);
      });
  };
  const handleInputChangeSalesChannelId = (e) => {
    setDefaultValues({ ...defaultValues, salesChannelId: e.key });
  };
  const handleInputChangeExternalSalesChannelId = (e) => {
    setDefaultValues({ ...defaultValues, externalSalesChannelId: e.key });
  };
  const handleImputSapCodeChange = (e) => {
    setDefaultValues({ ...defaultValues, sapCode: e.target.value });
  };
  const changePage = (event, value) => {
    reloadData(value, false);
  };
  const preDelete = (externalSalesChannelId) => {
    setDeleteDialog({ open: true, id: externalSalesChannelId });
  };
  const deleteSalesChannel = (id) => {
    setDeleteDialog({ ...deleteDialog, open: false });
    setIsLoading(true);
    api
      .deleteSalesChannel(id)
      .then((res) => {
        reloadData(1, true);
        setIsLoading(false);
        utils.alertSuccess("Canal de venta eliminado correctamente.");
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.data.errores) {
          utils.alertError(err.response.data.errores[0]);
        } else {
          shortError("Ocurrió un error");
        }
      });
  };
  const ConfirmEditSalesChannel = () => {
    setIsLoading(true);
    if (checkValueEditSalesChannel()) {
      var body = {
        companiaId: defaultValues.companyId,
        canalDeVentaId: defaultValues.salesChannelId,
        canalVentaExternoId: defaultValues.externalSalesChannelId,
        codigoCanalVentaSap: defaultValues.sapCode?.trim(),
      };
      api
        .putSalesChannelCompany(defaultValues.id, body)
        .then((res) => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: "Canal de venta editado correctamente.",
            type: "success",
          });
          reloadData(1, true);
        })
        .catch((err) => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: err.response.data.errores ?? "Ocurrió un error.",
            type: "error",
          });
        });
      setOpenEdit(false);
    } else if (!defaultValues.companyId) {
      shortError("Debe seleccionar una compañía.");
    } else if (!defaultValues.salesChannelId) {
      shortError("Debe seleccionar un canal de venta.");
    } else if (!defaultValues.externalSalesChannelId) {
      shortError("Debe seleccionar un canal de venta externo.");
    }
  };
  const checkValueEditSalesChannel = () => {
    let response = false;

    if (defaultValues.companyId && defaultValues.externalSalesChannelId && defaultValues.salesChannelId) {
      response = true;
    }
    return response;
  };
  useEffect(() => {
    setIsLoading(true);
    api
      .getCompanies()
      .then((res) => {
        setCompaniesListEdit(utils.setDataInSearchList(res.data));
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  return (
    <>
      {dataTable && dataTable.length > 0 ? (
        <Paper className="c-mt-20 c-grid-results" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TableContainer>
                <Table className="c-table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell className="c-w-20">Compañia</TableCell>
                      <TableCell className="c-w-20">Canal de Venta</TableCell>
                      <TableCell className="c-w-20">Canal de Venta Externo</TableCell>
                      <TableCell className="c-w-20">Canal de Venta SAP</TableCell>
                      <TableCell className="c-w-10">Opciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataTable.map(
                      ({ id, companyName, salesChannelName, externalSalesChannelName, sapSalesChannelCode }) => (
                        <TableRow key={id}>
                          <TableCell className="c-w-20">{companyName}</TableCell>
                          <TableCell className="c-w-30">{salesChannelName}</TableCell>
                          <TableCell>{externalSalesChannelName}</TableCell>
                          <TableCell>{sapSalesChannelCode}</TableCell>
                          <TableCell className="c-w-20">
                            <Tooltip title="Editar" arrow>
                              <IconButton
                                className="c-grid-btn-edit button-grid"
                                onClick={() => {
                                  handleClickEdit(id);
                                  setOpenEdit(true);
                                }}
                              >
                                <CreateIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Dar de baja" arrow>
                              <IconButton className="c-grid-btn-cancel button-grid" onClick={() => preDelete(id)}>
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} container direction="column" alignItems="center" justify="center">
              <Pagination
                className="c-pagination"
                onChange={changePage}
                page={paginationData.currentPage}
                count={paginationData.count > 1 ? paginationData.count : 0}
                shape="rounded"
              />
            </Grid>
          </Grid>
        </Paper>
      ) : (
        <Paper className="c-mt-20" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} className="c-text-center">
              <h5>No se encontraron resultados.</h5>
            </Grid>
          </Grid>
        </Paper>
      )}
      {deleteDialog !== undefined && (
        <ConfirmDialog
          open={deleteDialog.open}
          message={"¿Desea eliminar el canal de venta?"}
          cancelAction={() => setDeleteDialog(false)}
          confirmAction={() => deleteSalesChannel(deleteDialog.id)}
        />
      )}
      {viewData && (
        <Dialog
          open={openEdit}
          onClose={() => setOpenEdit(false)}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          classes={{
            paperFullWidth: classes.paperFullWidth,
          }}
        >
          <DialogTitle id="form-dialog-title">Editar Canal de Venta</DialogTitle>
          <DialogContent
            classes={{
              root: classes.dialogContentRoot,
            }}
            style={{ maxWidth: 300 }}
          >
            <ReactSelect
              styles={{ maxWidth: 350 }}
              placeholder="Asociar Compañía..."
              options={companiesListEdit}
              value={companiesListEdit.filter((option) => option.key === defaultValues.companyId)}
              isDisabled
            />
          </DialogContent>
          <DialogContent
            classes={{
              root: classes.dialogContentRoot,
            }}
            style={{ maxWidth: 300 }}
          >
            <ReactSelect
              styles={{ maxWidth: 350 }}
              placeholder="Asociar canal de venta..."
              options={salesChannelListEdit}
              value={salesChannelListEdit.filter((option) => option.key === defaultValues.salesChannelId)}
              onChange={handleInputChangeSalesChannelId}
            />
          </DialogContent>
          <DialogContent
            classes={{
              root: classes.dialogContentRoot,
            }}
            style={{ maxWidth: 300 }}
          >
            <ReactSelect
              styles={{ maxWidth: 350 }}
              placeholder="Asociar canal de venta externo..."
              options={externalSalesChannelListEdit}
              value={externalSalesChannelListEdit.filter(
                (option) => option.key === defaultValues.externalSalesChannelId
              )}
              onChange={handleInputChangeExternalSalesChannelId}
            />
          </DialogContent>
          <DialogContent>
            <TextField
              margin="dense"
              id="sapCode"
              label="Código Canal de Venta SAP"
              type="text"
              name="codigoSap"
              value={defaultValues.sapCode}
              onChange={handleImputSapCodeChange}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenEdit(false)} className="c-btn-cancel">
              Cancelar
            </Button>
            <Button onClick={() => ConfirmEditSalesChannel()} className="c-btn-success">
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
